import { addDataLayerEntry } from '@printdeal/data-layer-manager';

export type DispatchCategoriesAccount = 'order_detail_interaction'
| 'order_detail_api_failure'
| 'order_overview'
| 'order_list_interaction'
| 'order_list_api_failure'
| 'proposal_detail_api_failure'
| 'survey_interaction'
| 'survey_api_failure'
| 'landingpage_reorder'
| 'landingpage_reorder_modal'
| 'landingpage_reorder_api_failure'
| 'subheader_reorder_click'
| 'complaint_order_search_order_api_failure';

export const dispatchAccountEvent = (
  category: DispatchCategoriesAccount,
  action: string,
  extraData: { [key:string] : any } | null = null,
) => {
  // GA4
  addDataLayerEntry(category, {
    action,
    ...(extraData), // optional spreading
  });
};
